import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'

import heroImg from 'assets/img/careers-page-hero.jpg'
import gridImage1 from 'assets/img/careers-page-grid1.png'
import gridImage2 from 'assets/img/careers-page-grid2.png'
import gridImage3 from 'assets/img/careers-page-grid3.png'
import gridImage4 from 'assets/img/careers-page-grid4.png'
import gridImage5 from 'assets/img/careers-page-grid5.png'

export default function CareersPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    initialInView: true,
    rootMargin: '1px',
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Jobs at Roaming Hunger - Roaming Hunger</title>
        <meta name="og:title" content="Jobs at Roaming Hunger"></meta>
        <meta name="description" content="Available careers and jobs at Roaming Hunger."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Jobs at Roaming Hunger"
          buttonText="See Open Positions"
          onButtonClick={() => {
            window.location.href = "https://angel.co/roaming-hunger/jobs"
          }}
          description={(
            <div>
              Do you love food? We are always looking for passionate, smart, fun people who love 
              to eat and want to be a part of an amazing story. Check out our open positions below!
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={() => {
            window.location.href = "https://angel.co/roaming-hunger/jobs"
          }}
          buttonText="See Open Positions"
        />
      )}
      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          What We're Building
        </h2>
        <p className="font-light text-gray-900 mt-6">
          Roaming Hunger’s mission is to enable businesses to create memorable events, anywhere, anytime. 
          We do this through our Catering and Events platform and our Experiential Marketing Agency, RMNG.
          <br /> <br />
          Since 2009, we’ve built the largest Catering and Events platform for food trucks in the US. 
          With over 23,000 food trucks, trailers, carts, and mobile caterers on our platform, we facilitate
          food experiences for events and hosts, whether it’s a backyard birthday party or a Fortune 100 
          company event.
          <br /> <br />
          Our award-winning experiential agency RMNG brings brands face-to-face with their customers by 
          creating unexpected moments in unexpected places. We can show up anywhere, anytime, whether it’s 
          Times Square or a rural town. For the last 12 years, we’ve worked with some of the world's largest 
          brands, including Pepsi, Barbie, and Walmart.
        </p>
      </div>
      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Our Values:
        </h2>
        <p className="font-light text-gray-900 mt-6">
          <b>Roaming:</b> We are curious, prioritizing learning and innovation in pursuit of continuous improvement. 
          We move forward through disciplined and intentional experimentation.
          <br /> <br />
          <b>Hunger:</b> We are relentless, energetic, and enthusiastic. We are hungry for results and pursue our 
          goals with tenacity and grit.
          <br /> <br />
          <b>Together:</b> We are a community serving communities. We win together for our vendors, clients, and our team.
          <br /> <br />
          <b>With Purpose:</b> We are driven to exceed expectations. We hold each other accountable and always do the right thing.
        </p>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Flexible Time Off"
          content="Work/life balance is something we care a lot about. When you need some discretionary time off, you have the flexibility to take it."
          image={gridImage1}
        />
        <OccasionPageGridRow
          heading="Personal Development and Growth"
          content="One of our core values is a commitment to constant learning and growth. We believe in working with you to achieve your professional and personal goals."
          image={gridImage2}
          reverse
        />
        {/* <OccasionPageGridRow
          heading="Food Truck Lunches"
          content="Every week we have a local LA food truck come out. It’s not just a great meal, it’s a chance to bond and connect with fellow team members and understand the magic behind what Roaming Hunger does."
          image={gridImage3}
        /> */}
        <OccasionPageGridRow
          heading="Dog Friendly"
          content="Our four-legged friends are as much a part of the team as anyone else, and are always around to brighten up your day (as long as you have a snack to give them)."
          image={gridImage4}
          reverse
        />
        <OccasionPageGridRow
          heading="Health Insurance"
          content="Physical and mental health is something we take seriously. We offer a wide range of health insurance options, including dental and vision."
          image={gridImage5}
        />
      </OccasionPageGrid>
    </Layout>
  )
}
